import React from "react";
import { BrowserRouter, Routes, Route, ScrollRestoration } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import QuickExit from "@/components/QuickExit";

import Home from "@/pages/Home";
import Guides from "@/pages/Guides";
import Services from "@/pages/Services";
import Inquire from "@/pages/Inquire";
import About from "@/pages/About";
import Success from "@/pages/Success";

function ScrollToTop() {
  const { pathname } = window.location;
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <ScrollToTop />
        <QuickExit />
        <Navbar />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/guides" element={<Guides />} />
            <Route path="/shop" element={<Guides />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/inquire" element={<Inquire />} />
            <Route path="/success" element={<Success />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#1A2F25",
            color: "#FAF7F2",
            border: "1px solid #1A2F25",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}
